import Vue from "vue";
// import './plugins/vuetify'
import Vuetify from "vuetify";

import "./stylus/main.styl";
import "@fortawesome/fontawesome-free/css/all.css"; // Ensure you are using css-loader
import nb from "./locales/vuetify/nb.ts";
import es from "./locales/vuetify/es.ts";
import en from "./locales/vuetify/en.ts";
import i18n from "./i18n";
import Croppa from "vue-croppa";
Vue.use(Croppa);

const VueMoment = require("vue-moment");
const moment = require("moment");
// require('moment/locale/es')
Vue.use(VueMoment, { moment });
import "vue-croppa/dist/vue-croppa.css";

let _language =
  window.navigator.userLanguage ||
  window.navigator.language ||
  process.env.VUE_APP_I18N_LOCALE;

i18n.locale = localStorage.getItem("setlanguage") || _language;
Vue.moment.locale(i18n.locale);
localStorage.setItem("detectedlanguage", Vue.moment().locale());
// Vuetify.lang.current = Vue.moment().locale();
Vue.use(Vuetify, {
  iconfont: "fa",
  lang: {
    locales: { nb, es, en },
    current: Vue.moment().locale()
  }
});
Vue.config.productionTip = false;

import App from "./App.vue";
import store from "./store/store";
import router from "./router/router";
import { mapGetters } from "vuex";

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  watch: {
    getLang(newLocale) {
      this.changeLocale(newLocale);
    }
  },
  computed: {
    ...mapGetters(["getLang"])
  },
  methods: {
    changeLocale(newLocale) {
      this.$i18n.locale = newLocale;
      this.$moment.locale(newLocale);
      this.$vuetify.lang.current = newLocale;
      localStorage.setItem("setlanguage", newLocale);
      // this.$store.dispatch("UPDATE_ALL_LANGUAGE_RELATED");
    }
  },
  mounted() {
    let _thisLanguage =
      localStorage.getItem("setlanguage") ||
      localStorage.getItem("detectedlanguage") ||
      "en";
    this.changeLocale(_thisLanguage);
  }
}).$mount("#app");
